<template>
	<div style="margin: 20px">
		<el-card shadow="never">
			<div>
                <el-table :data="tableData" row-key="id" border :stripe="true">
                    <el-table-column width="150" prop="payMeterNo" label="表号"></el-table-column>
                    <el-table-column width="160" prop="accrualDate" label="应收期数"></el-table-column>
                    <el-table-column width="100" prop="useNum" label="用量"></el-table-column>
                    <el-table-column prop="money" label="应缴金额"></el-table-column>
                </el-table>
            </div>

			<div style="margin-top: 10px">
				<el-form
					size="small"
					:inline="true"
					label-position="right"
					label-width="100px"
					:rules="rules"
					:model="formData"
				>
					<el-form-item label="发票号码" prop="invoiceNo">
						<el-input size="small" width="300" v-model="formData.invoiceNo" placeholder="请输入发票号码" clearable></el-input>
					</el-form-item>
					<el-form-item label="开票时间" prop="invoiceTime">
						<el-date-picker size="small" v-model="formData.invoiceTime" type="datetime" placeholder="选择开票时间"> </el-date-picker>
					</el-form-item>
					<el-form-item label="缴费日期" prop="payTime">
						<el-date-picker size="small" v-model="formData.payTime" type="datetime" placeholder="请输入缴费日期"> </el-date-picker>
					</el-form-item>
					<el-form-item label="收费方式" prop="payMode">
						<el-select size="small" v-model="formData.payMode" placeholder="收费方式">
							<el-option v-for="item in payMode" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="缴费金额(元)" prop="payAmount">
						<el-input-number
							v-model="formData.payAmount"
							:controls="false"
							:disabled="disabledInput"
							placeholder="请输入缴费金额"
							:readonly="!autoFlag"
						></el-input-number>
					</el-form-item>
					<el-form-item label="预存金额(元)" prop="payReAmount">
						<el-input-number
							v-model="formData.payReAmount"
							:controls="false"
							:disabled="disabledInput"
							placeholder="请输入预存金额"
						></el-input-number>
					</el-form-item>
					<el-form-item label="备注">
						<el-input
							size="small"
							type="textarea"
							v-model="formData.remarks"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请输入备注"
							clearable
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<p style="color:red; margin: 10px 0px">*请先选择缴费日期以后才能填写缴费金额和预存金额</p>
			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSaveForm">保存</el-button>
				<el-button size="small" @click="doClose">关闭</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
import mixin from "@/mixin/index";
import dlgForm from "@/mixin/dlgForm";
import moment from "moment";
import { payMode } from "@/dict/meterDict";
import { get} from "@/assets/common/request";

export default {
	name: "OfflineChargeForm",
	mixins: [mixin, dlgForm],
	props: {
		meterId: {
			type: String,
			default: undefined,
		},
		autoFlag: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			payMode,
			formData: {
				invoiceNo: "",
				invoiceTime: this.now(),
				payTime: this.now(),
				payMode: 1,
				meterId: this.meterId,
			},
			rules: {
				invoiceNo: [{ required: true, message: "请输入发票号码", trigger: "blur" }],
				invoiceTime: [{ required: true, message: "选择开票时间", trigger: "blur" }],
				payTime: [{ required: true, message: "请输入缴费日期", trigger: "blur" }],
				payMode: [{ required: true, message: "请选择收费方式", trigger: "blur" }],
				payAmount: [
					{ required: true, message: "请输入缴费金额", trigger: "blur" },
					{ type: "number", min: 0, message: "必须是正数", trigger: "blur" },
				],
				payAmount: [{ type: "number", min: 0, message: "必须是正数", trigger: "blur" }],
			},
		};
	},
	methods: {
		doSaveForm() {
            const url = "meter/web/order/offlineCharge";
            this._doSaveForm(this.$refs.form, url, 'POST');
		},
        doSaveAfter(data) {
            if(data && data.data) {
                console.info(data.data)
                this.$emit("after", data.data);
            }
        },
        doCloseAfter(data) {
            this.$emit("after", data);
        },
		loadData() {
			const url = "meter/web/handwork/handworkRecord";
			const params = { meterId: this.meterId };
			get(url, params).then((data) => {
				this.tableData = data.data;
			});
		},
		now() {
			return moment().format("YYYY-MM-DD HH:mm:ss");
		},
	},
	computed: {
		disabledInput() {
			return !this.formData.payTime;
		},
	},
	mounted() {
		if (this.meterId) {
			this.query.meterId = this.meterId;
			this.loadData();
		}
	},
};
</script>
<style scoped>
.el-input-number::v-deep .el-input__inner {
	text-align: left;
}
</style>
